module.exports = __webpack_public_path__ + "static/media/preventivo_rojo.d8d6dfa9.svg";